import { Controller } from "@hotwired/stimulus"

// 汎用アコーディオン。トリガークリックでパネルを開閉し、アイコンの向きを切り替える。
// 使い方:
//   <div data-controller="accordion">
//     <button data-action="accordion#toggle">...</button>
//     <div data-accordion-target="panel">...</div>
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = ["panel", "icon"]

  declare readonly panelTarget: HTMLElement
  declare readonly iconTarget: HTMLElement

  toggle(event: Event) {
    const trigger = event.currentTarget as HTMLElement
    const hidden = this.panelTarget.classList.toggle("hidden")

    this.iconTarget.classList.toggle("rotate-180", !hidden)
    trigger.setAttribute("aria-expanded", (!hidden).toString())
  }
}
